import React from "react";
import { object, array } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import get from "lodash/get";

import { getSlug } from "../../../helper/utils";

import "./collection-heading.m.css";

const CollectionHeading = ({ collection = {}, sections = [] }) => {
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], collection.name);
  const collectionSlug = getSlug(collection, sections, navigateTo);

  return (
    <Link href={collectionSlug}>
      <h3 styleName="collection-heading">{navigateToTitle}</h3>
    </Link>
  );
};

CollectionHeading.propTypes = {
  collection: object.isRequired,
  sections: array
};

const mapStateToProps = state => ({
  sections: get(state, ["qt", "config", "sections"], null)
});

export default connect(mapStateToProps)(CollectionHeading);
